<template>
    <transition name="dmv-modal">
        <div class="dmv-modal" >
            <div class="dmv-modal__backdrop" v-on:click="close"></div>
            <div class="dmv-modal__container" ref="container">
                <button v-if="buttonClose" type="button" class="btn btn--nop dmv-modal__close" v-on:click="close">
                    <svg width="24" height="24" viewBox="0 0 24 24">
                        <path fill="currentColor"
                              d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"></path>
                    </svg>
                </button>
                <slot name="content"></slot>
                <slot name="footer"></slot>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: 'dm-modal',
        props: {
            show: {
                type: Boolean,
                default: false
            },
            buttonClose: {
                type: Boolean,
                default: true
            }
        },
        methods: {
            close() {
                this.$emit('close');
            }
        }
    };
</script>
